import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Box, Modal, Button, Stack, Typography } from '@mui/material';
import { getTipoAnexo } from './api';
import { cores } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '90vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw',
    height: '70vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

const sxFontBotaoMobile = {
  '@media screen and (max-width: 600px)': {
    fontSize: 10,
  },
};

const ModalValidaAnexos = React.forwardRef((props, ref) => {
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    fetchTipos();
  }, []);

  const fetchTipos = async () => {
    const result = await getTipoAnexo();
    const isBombeamento = props.isBombeamento;
    const isOffGrid     = props.isOffGrid;
    const isFluxoSimplificado = isBombeamento || isOffGrid;

    const tiposFiltrados = result.filter(tipo => {
      // Filtra por tipocontratante
      if (tipo.tipocontratante && tipo.tipocontratante !== props.tipocontratante) return false;
      // Filtra por tipoproposta
      if (!tipo.tipoproposta || tipo.tipoproposta === 'todos' || tipo.tipoproposta === 'ambos') return true;
      if (isBombeamento && tipo.tipoproposta === 'bombeamento') return true;
      if (isOffGrid    && tipo.tipoproposta === 'offgrid')     return true;
      if (!isFluxoSimplificado && tipo.tipoproposta === 'ongrid') return true;
      return false;
    });
    setTipos(tiposFiltrados);
  };

  const onConfirm = () => {
    props.onConfirm();
  };

  // Filtra os tipos obrigatórios para exibir na lista
  const tiposObrigatorios = tipos.filter(tipo => tipo.obrigatorio === true);

  // Verifica quais tipos obrigatórios estão presentes nos anexos
  const anexosPresentes = props.anexos || [];
  const verificarAnexosObrigatorios = tiposObrigatorios.map(tipoObrigatorio => {
    const presente = anexosPresentes.some(anexo => anexo.tipo?._id === tipoObrigatorio._id);
    return { ...tipoObrigatorio, presente };
  });

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h6" component="h2" sx={{ color: cores.textoClaro }}>
          Verificação de Anexos Obrigatórios
        </Typography>

        {/* Lista de tipos obrigatórios com a cor baseada na presença do anexo */}
        <Box sx={{ mt: 2, width: '100%' }}>
          {verificarAnexosObrigatorios.map((tipo) => (
            <Typography
              key={tipo._id}
              sx={{
                color: tipo.presente ? 'green' : 'red',
                fontWeight: tipo.presente ? 'bold' : 'normal',
              }}
            >
              {tipo.nome} - {tipo.presente ? 'Presente' : 'Faltando'}
            </Typography>
          ))}
        </Box>

        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5}>
          <Button variant="outlined" onClick={props.onClose} color="error">Fechar</Button>
          
        </Stack>
      </Box>
    </Modal>
  );
});

ModalValidaAnexos.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  anexos: PropTypes.array,
  tipocontratante: PropTypes.string,
};

export default ModalValidaAnexos;